export const getPurchaseDomain = (domain: string) => {
  if (domain.endsWith('.br'))
    return { name: 'registro.br', href: 'https://registro.br/' };
  if (domain.endsWith('.ar'))
    return { name: 'nic.ar', href: 'https://nic.ar/buscar-dominio' };
  if (domain.endsWith('.com.co'))
    return { name: 'mi.com.co', href: 'https://mi.com.co/' };
  return null;
};
